<div class="row center-align-children mt-3 mb-3">
  <div class="col">
    <input class="form-control"
      id="employees-search"
      type="text"
      placeholder="Search for employee"
      [(ngModel)]="searchModel">
  </div>
</div>

<app-sortable-table [headers]="headers" (sort)="onSort($event)">
  @for (employee of employees() | listFilter: searchModel: 'name' | listSort: tableSortEvent; track employee) {
    <tr>
      <td><a routerLink="/employees/{{storeId()}}/{{employee.employeePositionId.parseEmployeeId()}}/{{employee.employeePositionId.parsePositionId()}}">{{ employee.name }}</a></td>
      <td>{{ employee.role | enumParse }}</td>
      <td>{{ employee.contractHours }} hr p/w</td>
      <td>{{getAvailability(employee)}}</td>
    </tr>
  }
</app-sortable-table>